import React, { useState, useEffect, useRef, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import moment from 'moment';
import ScreenLayoutServices from '../../services/externalServices/TicketServices/screenLayoutServices';
import GatewayV2Services from '../../services/externalServices/TicketServices/gatewayV2Services';
import PaymentServices from '../../services/externalServices/TicketServices/paymentServices';
import PricingConfigServices from '../../services/externalServices/TicketServices/pricingConfigServices';
import PaymentSplitDetails from './PaymentSplitDetails';
import phonepeLogo from '../../../assets/images/phonepe.png'; // Adjust the path as necessary
import cashImg from '../../../assets/images/cash.png'; // Adjust the path as necessary
import BookingBreadcrumb from "../components/BookingBreadcrumb";




// Add at the top with other imports
import { useContext } from 'react';
import { BookingContext } from '../../../context/BookingContext'







const ConfirmTicket = () => {
  const formatTime = (seconds) => `${String(Math.floor(seconds / 60)).padStart(2, '0')}:${String(seconds % 60).padStart(2, '0')}`;

  const location = useLocation();
  const navigate = useNavigate();
  const {
    showtimeId, theatreId, bookedSeats, date, time,
    totalPrice, movie, nameOfTheatre, maxTimeLimit, code, passedPhoneNumber,isSectionLayout
  } = location.state || {};

  const [taxes, setTaxes] = useState(0);
  const [ticketTotal, setTicketTotal] = useState(0);
  const [error, setError] = useState(null);
  const isHandlingPop = useRef(false);
  // const [timeRemaining, setTimeRemaining] = useState(500);
  // const [timeRemaining, setTimeRemaining] = useState(maxTimeLimit || 1380);

  // const [timeRemaining, setTimeRemaining] = useState(maxTimeLimit);
  // const [isExpired, setIsExpired] = useState(false);
  const [pricing, setPricing] = useState(null);
  const [loadingPricing, setLoadingPricing] = useState(false);
  const [showModal, setShowModal] = useState(false);
  // const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneNumber, setPhoneNumber] = useState(passedPhoneNumber || '');

  const [paymentMethod, setPaymentMethod] = useState('PhonePe');
  const [paymentGateway, setPaymentGateway] = useState('PhonePe');
  const [paymentChannel, setPaymentChannel] = useState('All'); // Credit Card | Debit Card | UPI | Netbanking | All
  const [couponCode, setCouponCode] = useState('');
  const [couponValid, setCouponValid] = useState(false);
  const { setNeedsRefresh } = useContext(BookingContext);

  const [bookingId, setBookingId] = useState();
  const [availableGateways, setAvailableGateways] = useState([]); // [{gateway, methods:[]}]
  const [gatewayMaster, setGatewayMaster] = useState([]); // [{_id,name,code,active}]

  const bypassPopconfirm = useRef(false); // Add this line

  const { firstname, role = "", accessList = [], _id } = JSON.parse(localStorage.getItem("admin"));

  // console.log('phone number========', phoneNumber)
// 
  // Expiration challenge

  // const [timeRemaining, setTimeRemaining] = useState(() => {
  //   // Check if we have a stored expiration time
  //   const storedExpiry = localStorage.getItem('bookingExpiry');
  //   if (storedExpiry) {
  //     const remaining = Math.max(0, Math.floor((parseInt(storedExpiry) - Date.now()) / 1000));
  //     return remaining > 0 ? remaining : 0;
  //   }
  //   // If no stored time, use the maxTimeLimit or default
  //   return maxTimeLimit || 1380;
  // });



  const [timeRemaining, setTimeRemaining] = useState(() => {
    const storedExpiry = sessionStorage.getItem('bookingExpiry');
    const now = Date.now();

    if (storedExpiry) {
      const remaining = Math.floor((parseInt(storedExpiry) - now) / 1000);
      return remaining > 0 ? remaining : 0;
    }

    // Set a new expiry ONLY if not already present
    const newExpiry = now + 1380 * 1000; // 23 mins from now
    sessionStorage.setItem('bookingExpiry', newExpiry.toString());
    return maxTimeLimit || 1380;
  });


  const [isExpired, setIsExpired] = useState(timeRemaining <= 0);

  const sectionDetails = useMemo(() => {
    if (!Array.isArray(bookedSeats)) return {};
    return bookedSeats.reduce((acc, seat) => {
      const section = seat.sectionName;
      if (!section) return acc;
      acc[section] = acc[section] || { price: seat.sectionPrice || 0, count: 0, convenienceFee: seat.sectionCF || 0 };
      acc[section].count++;
      return acc;
    }, {});
  }, [bookedSeats]);


console.log('isSectionLayout==========in confrimTicket===========',isSectionLayout);

  useEffect(() => {

    console.log('ticketTotal?.value', ticketTotal?.value)
    const formattedDate = moment(date).format('YYYY-MM-DD');
    const initiateManualBooking = async () => {
      const payload = {
        movieId: movie._id,
        theatreId,
        showtimeId,
        bookedSeats,
        date: formattedDate,
        time,
        phoneNumber: `91${phoneNumber}`,
        isSectionLayout

      };

      try {
        console.log('payload at the time of the initiateManual', payload)

        // console.log(await PaymentServices.createManualBooking(payload));

        const response = await PaymentServices.createManualBooking(payload);
        // const response = await axios.post('http://localhost:4123/api/payment/createOrUpdateManualBooking', payload);
        console.log('🆕 INITIATED booking response:', response);

        // Save booking ID to update payment later
        setBookingId(response?.bookingId);
      } catch (error) {
        console.error('❌ Failed to initiate manual booking:', error);
      }
    };

    initiateManualBooking();
    // Fetch dynamic gateways for Tickets + theatreId
    (async () => {
      try {
        const resp = await PaymentServices.getAvailableGateways({ serviceType: 'Tickets', serviceId: theatreId });
        if (resp?.success && Array.isArray(resp.gateways)) {
          setAvailableGateways(resp.gateways);
        } else {
          setAvailableGateways([]);
        }
        // Load gateway master for mapping display name -> code
        try {
          const gm = await PricingConfigServices.listGatewaysMaster();
          const list = gm?.data || gm || [];
          setGatewayMaster(Array.isArray(list) ? list : []);
        } catch (e) { setGatewayMaster([]); }
      } catch (e) {
        console.error('Failed to load gateways', e);
        setAvailableGateways([]);
      }
    })();
  }, []);


  const calculatePricing = async (method, gatewayOverride = null, methodChannelOverride = null, couponOverride = undefined) => {
    try {
      setLoadingPricing(true);

      console.log('method in the calculatePricing', method, 'gatewayOverride', gatewayOverride);
      let response;
      const basePayload = {
        amount: totalPrice,
        tickets: JSON.parse(JSON.stringify(sectionDetails)),
        theatreId,
      };
      // Legacy flow for PhonePe or Cash (Counter)
      const gw = gatewayOverride ?? paymentGateway;
      if (gw === 'PhonePe' || method === 'Cash') {
        response = await PaymentServices.calculatePricing({
          ...basePayload,
          paymentMethod: method
        });
      } else {
        // v2 flow for non-legacy gateways
        // Determine coupon to send: undefined means no coupon applied.
        let couponToSend;
        if (couponOverride === undefined) {
          couponToSend = couponValid ? couponCode : undefined;
        } else if (couponOverride === null || couponOverride === '') {
          // Explicit removal requested
          couponToSend = undefined;
        } else {
          couponToSend = couponOverride;
        }

        const v2Payload = {
          ...basePayload,
          serviceType: 'Tickets',
          serviceId: theatreId,
          gateway: gw,
          paymentMethod: methodChannelOverride || paymentChannel || method,
          // Use explicit couponToSend to allow explicit removal (null/empty -> no coupon)
          couponCode: couponToSend,
        };
        response = await PaymentServices.calculatePricingV2(v2Payload);
      }
      setPricing(response.data);
    } catch (err) {
      console.error('Pricing error:', err);
      setError('Failed to calculate pricing');
    } finally {
      setLoadingPricing(false);
    }
  };

  useEffect(() => {
    if (pricing) {
      const baseIGST = pricing.tax?.igst?.value || 0;
      const platformFeeIGST = pricing.platformFee?.tax?.igst?.value || 0;
      setTaxes(baseIGST + platformFeeIGST);
      setTicketTotal(pricing.finalAmount);
    }
  }, [pricing]);

  // Ensure default selection and get initial pricing for PhonePe
  useEffect(() => {
    // Make sure we have a payment method selected
    setPaymentMethod(prev => prev || 'PhonePe');
    // Trigger calculation explicitly for PhonePe (legacy flow)
    calculatePricing('PhonePe', 'PhonePe', 'All');
  // Re-run if core inputs change
  }, [totalPrice, sectionDetails, theatreId]);

  const parseNumberSafe = (val) => {
    if (typeof val === 'object' && val?.value !== undefined) {
      return parseFloat(val.value);
    }
    return Number(val);
  };

  // useEffect(() => {
  //   if (!pricing || !bookingId) return;

  //   const formattedDate = moment(date).format('YYYY-MM-DD');
  //   const baseIGST = pricing.tax?.igst?.value || 0;
  //   const platformFeeIGST = pricing.platformFee?.tax?.igst?.value || 0;
  //   const totalTaxes = baseIGST + platformFeeIGST;
  //   const totalAmount = parseNumberSafe(pricing.finalAmount);

  //   setTaxes(totalTaxes);

  //   setTicketTotal(pricing.finalAmount);

  //   const updateManualBooking = async () => {
  //     const payload = {
  //       movieId: movie._id,
  //       theatreId,
  //       showtimeId,
  //       bookedSeats,
  //       date: formattedDate,
  //       time,
  //       totalAmount,
  //       taxes: totalTaxes,
  //       bookingId, // this is important to UPDATE the existing record
  //     };

  //     try {
  //       const response = await PaymentServices.createManualBooking(payload);
  //       console.log('✅ Updated booking with pricing:', response);
  //     } catch (error) {
  //       console.error('❌ Failed to update booking with pricing:', error);
  //     }
  //   };

  //   updateManualBooking();
  // }, [pricing, bookingId]);



  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     setTimeRemaining((prev) => {
  //       if (prev <= 1) {
  //         clearInterval(timer);
  //         setIsExpired(true);
  //         return 0;
  //       }
  //       return prev - 1;
  //     });
  //   }, 1000);
  //   return () => clearInterval(timer);
  // }, []);


  // useEffect(() => {
  //   // Calculate expiration time (current time + timeRemaining seconds)
  //   const expiryTime = Date.now() + (timeRemaining * 1000);
  //   localStorage.setItem('bookingExpiry', expiryTime.toString());

  //   const timer = setInterval(() => {
  //     setTimeRemaining((prev) => {
  //       const newTime = prev - 1;
  //       if (newTime <= 0) {
  //         localStorage.removeItem('bookingExpiry');
  //         clearInterval(timer);
  //         setIsExpired(true);
  //         return 0;
  //       }
  //       return newTime;
  //     });
  //   }, 1000);

  //   return () => {
  //     clearInterval(timer);
  //     // Don't remove from localStorage here - we want it to persist
  //   };
  // }, []); // Empty dependency array to run only once on mount





  useEffect(() => {
    const timer = setInterval(() => {
      setTimeRemaining(prev => {
        const next = prev - 1;
        if (next <= 0) {
          sessionStorage.removeItem('bookingExpiry'); // Clean it up
          clearInterval(timer);
          setIsExpired(true);
          return 0;
        }
        return next;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);




  useEffect(() => {
    const handlePopState = async () => {

      if (bypassPopconfirm.current) return;



      if (isHandlingPop.current || isExpired) return;


      isHandlingPop.current = true;

      if (window.confirm('Cancel the booking and go back?')) {
        await handleCancelBooking();
      } else {
        // window.history.pushState(null, '', window.location.href);
        isHandlingPop.current = false;
      }
    };
    // window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, [isExpired]);








  // // For manual cancellation
  // const handleCancelClick = async () => {
  //   if (isExpired) return;

  //   // const confirmCancel = window.confirm('Are you sure you want to cancel this booking?');
  //   // if (confirmCancel) {
  //   await handleCancelBooking();
  //   // }
  // };



  // // For expiration flow
  // useEffect(() => {
  //   const handleExpiration = async () => {
  //     if (isExpired) {
  //       const confirmExpiry = window.alert('Your booking session has expired. The booking will be cancelled.');
  //       // const confirmExpiry = window.confirm('Your booking session has expired. Would you like to cancel?');
  //       if (confirmExpiry) {
  //         await handleCancelBooking();
  //       } else {
  //         await handleCancelBooking();
  //         // navigate('/');
  //       }
  //     }
  //   };

  //   handleExpiration();
  // }, [isExpired, navigate]);

  useEffect(() => {
    return () => {
      // Only clean up if booking isn't completed (no payment made)
      if (!showModal && !isExpired) {
        sessionStorage.removeItem('bookingExpiry');
        // Release held coupon if any
        const held = sessionStorage.getItem('couponBookingId');
        if (held) {
          PaymentServices.releaseCoupon({ bookingId: held }).catch(()=>{});
          sessionStorage.removeItem('couponBookingId');
        }
      }
    };
  }, [showModal, isExpired]);



  useEffect(() => {
    if (isExpired) {
      sessionStorage.removeItem('bookingExpiry'); // This is already in your code
      handleCancelBooking();
    }
  }, [isExpired]);

  // const toggleModal = () => setShowModal(!showModal);

  // const handleModalSubmit = (phone) => {
  //   setPhoneNumber(phone);
  //   if (paymentMethod === 'PhonePe') handlePhonePePayment(phone);
  //   else handlePayment();
  // };


  // const toggleModal = () => setShowModal(!showModal);

  const handleModalSubmit = (phone) => {
    // Legacy gateways use existing handlers; any other gateway goes via v2
    if (paymentGateway === 'PhonePe') return handlePhonePePayment(phone);
    if (paymentGateway === 'Cash') return handlePayment();
    return handleV2Payment(phone);
  };





  const formattedDate = moment(date).format('YYYY-MM-DD');
  console.log('date=================', formattedDate);

  const handlePayment = async () => {

    sessionStorage.removeItem('bookingExpiry'); // Add this line

    console.log('handle payment=============', bookingId)
    const payload = {
      movieId: movie._id,
      theatreId,
      showtimeId,
      bookedSeats,
      date: formattedDate,
      time,
      totalAmount: ticketTotal?.value,
      taxes,
      // transactionId: 'CASH' + Date.now(),
      // transactionStatus: '',
      // paymentMethod: 'Cash',
      // paymentMode: 'OFFLINE',
      transactionId: 'CASH' + Date.now(),
      transactionStatus: 'Success',
      paymentMethod: 'Cash',
      paymentMode: 'Offline',

      priceSplit: pricing,
      paymentDetails: {},
      bookingId,
      isSectionLayout
    };
    try {
      const response = await PaymentServices.createManualBooking(payload);

      console.log('respones in manual booking&&&&&&&&&&&&&&&&&&&&&&&&', response);
      if (response?.message === 'Manual booking with payment created successfully') {
        navigate('/paymentTicket', {
          state: {
            movie, theatreId, showtimeId, bookedSeats,
            date, time, totalPrice: response.paymentInfo.totalAmount,
            taxes: response.paymentInfo.taxes, ticketTotal,
            transactionId: response.paymentInfo.transactionId,
            transactionStatus: response.paymentInfo.transactionStatus,
            nameOfTheatre, bookingId: response.bookingId, phoneNumber,maxTimeLimit:maxTimeLimit,code:code, isSectionLayout:isSectionLayout
          }, replace: true
        });
      } else throw new Error('Booking failed');
    } catch (err) {
      setError('Failed to complete booking. Try again.');
    }
  };
  




  // For creating a new when the merchantId changes 

  const getFallbackBookingId = () => {
    // Logic to generate or fetch a fallback trip ID
    return `FB_${Date.now()}`; // Example: Generates "FB_<timestamp>"
  };

  const generateTranscationID = () => {
    const timestamp = Date.now();
    // const random = Math.floor(Math.random() * 100000);

    const randomThreeDigitNumber = Math.floor(100 + Math.random() * 900);
    const merchantPrefix = "T";
    // Check if tripId is valid; otherwise, use a dynamically generated fallback
    const validBookingId = bookingId && bookingId.trim() !== "" ? bookingId : getFallbackBookingId();
    // const validPaymentId = paymentId && paymentId.trim() !== "" && paymentId;
    const finalCTY = code ? code : "CTY"; // "CTY" is a default string fallback
    // return `${merchantPrefix}${timestamp}${random}`;
    // return `${validBookingId}_${randomThreeDigitNumber}`;
    return `${finalCTY}M${randomThreeDigitNumber}_${validBookingId}`;
  };


  const handlePhonePePayment = async (phone) => {
    // localStorage.removeItem('bookingExpiry'); // Add this line
    sessionStorage.removeItem('bookingExpiry'); // Add this line


    let merchantTransactionId = generateTranscationID();

    console.log('the value of the merchant transcation id before sned the payload', merchantTransactionId);


    try {
      const amount = ticketTotal?.value;

      const totalAmount = parseNumberSafe(pricing.finalAmount);


      // ✅ First update manual booking with phone number
      const updatePayload = {
        movieId: movie._id,
        theatreId,
        showtimeId,
        bookedSeats,
        date: formattedDate,
        time,
        totalAmount: amount,
        taxes,


        status: "PAYMENT_INITIATED",
        // phoneNumber, // ✅ include phone
        bookingId,
        priceSplit: pricing,
        merchantTransactionId: merchantTransactionId,
      };

      await PaymentServices.createManualBooking(updatePayload);





      const response = await PaymentServices.phonePePayment({ amount, mobileNumber: phone, bookingId: bookingId, code, merchantTransactionId: merchantTransactionId });
      if (response.success && response.paymentUrl) {
        const tempBooking = {
          movie, theatreId, showtimeId, bookedSeats, date, time,
          totalPrice: amount, taxes, transactionId: 'PHONEPE_' + Date.now(),
          nameOfTheatre, phoneNumber: phone, priceSplit: pricing, bookingId: bookingId,
          maxTimeLimit:maxTimeLimit,code:code,isSectionLayout:isSectionLayout
          
        };

        console.log('before temp bpoking===', bookedSeats);
        sessionStorage.setItem('tempPhonePeBooking', JSON.stringify(tempBooking));
        window.location.href = response.paymentUrl;
      } else throw new Error();
    } catch {
      setError('PhonePe payment failed. Try again.');
    }
  };

  // Generic v2 payments handler — uses Payments v2 initiate
  const handleV2Payment = async (phone) => {
    sessionStorage.removeItem('bookingExpiry');

    let merchantTransactionId = generateTranscationID();

    try {
      const amount = ticketTotal?.value;

      const totalAmount = parseNumberSafe(pricing.finalAmount);

      // Update manual booking with phone number and initiate payment status
      const updatePayload = {
        movieId: movie._id,
        theatreId,
        showtimeId,
        bookedSeats,
        date: formattedDate,
        time,
        totalAmount: amount,
        taxes,
        status: "PAYMENT_INITIATED",
        bookingId,
        priceSplit: pricing,
        merchantTransactionId: merchantTransactionId,
      };

      await PaymentServices.createManualBooking(updatePayload);

      // Call Payments v2 initiate (generic)
      const successBase = `${window.location.origin}/#/paymentsV2/status/`;
      // Map selected gateway display name (e.g., 'Unlimit') to configured profile code (e.g., 'UNL')
      const selectedGatewayName = paymentGateway;
      const profileCode = (gatewayMaster.find(g => String(g.name).toLowerCase() === String(selectedGatewayName).toLowerCase())?.code) || selectedGatewayName;

      const resp = await GatewayV2Services.initiatePayment({
        serviceType: 'Tickets',
        serviceId: theatreId,
        bookingId,
        amount,
        currency: 'INR',
        gateway: profileCode,
        method: paymentChannel || 'All',
        contact: { phone },
        returnUrls: { webSuccess: successBase }
      });

      const action = resp?.action || resp?.data?.action;
      const merchantOrderId = resp?.merchantOrderId || resp?.data?.merchantOrderId;
      const paymentUrl = action?.data;

      if (action?.type === 'redirect' && paymentUrl) {
        const tempBooking = {
          movie, theatreId, showtimeId, bookedSeats, date, time,
          totalPrice: amount, taxes, transactionId: merchantOrderId,
          nameOfTheatre, phoneNumber: phone, priceSplit: pricing, bookingId: bookingId,
          maxTimeLimit:maxTimeLimit,code:code,isSectionLayout:isSectionLayout
        };
        sessionStorage.setItem('tempV2Booking', JSON.stringify(tempBooking));
        window.location.href = paymentUrl;
      } else {
        throw new Error('Payment initiation failed');
      }
    } catch (err) {
      console.error('v2 payment error:', err);
      setError('Payment failed. Try again.');
    }
  };

  const handleCancelBooking = async () => {
    // localStorage.removeItem('bookingExpiry'); // Add this line
    sessionStorage.removeItem('bookingExpiry'); // Add this line

    console.log('handle cancel bookig', date);
    console.log('handle cancel bookig', moment(date).format('YYYY-MM-DD'));
    console.log('bookingId', bookingId);
    try {
      const response = await ScreenLayoutServices.cancelBooking({
        showtimeId,
        theatreId,
        cancelledSeats: bookedSeats,
        date: moment(date).format('YYYY/MM/DD'),
        // date: moment(date).format('YYYY-MM-DD'),
        time,
        status: isExpired ? 'SESSION_EXPIRED' : 'CANCELLED',

        bookingId: bookingId
      });
      if (response.message === 'Seats cancelled successfully') {
        setNeedsRefresh(true);
        navigate(-1);
        // navigate('/bookedSeats', {
        //               state: { theatreId, showtimeId, date, time, movie, nameOfTheatre, forceReload: true }
        //             });
      }
    } catch (err) {
      setError('Failed to cancel booking');
    }
  };






  // const handleCancelBooking = async (navigateAfterCancel = true) => {
  //   try {
  //     const payload = {
  //       showtimeId,
  //       theatreId,
  //       cancelledSeats: bookedSeats,
  //       date: moment(date).format('YYYY/MM/DD'),
  //       time,
  //       status: isExpired ? 'SESSION_EXPIRED' : 'CANCELLED',
  //       bookingId: bookingId
  //     };

  //     const response = await ScreenLayoutServices.cancelBooking(payload);

  //     if (response.message === 'Seats cancelled successfully') {
  //       // Use functional update to ensure we have latest state
  //       setNeedsRefresh(prev => {
  //         // Navigate after state is updated
  //         if (navigateAfterCancel) {
  //           setTimeout(() => {
  //             // navigate(-1, { state: { forceReload: true } });

  //             navigate('/bookedSeats', {
  //               state: { theatreId, showtimeId, date, time, movie, nameOfTheatre, forceReload: true }
  //             });
  //           }, 0);
  //         }
  //         return true;
  //       });
  //       return true;
  //     }
  //     throw new Error('Failed to cancel booking');
  //   } catch (error) {
  //     console.error('Cancel error:', error);
  //     setError('Failed to cancel booking. Please try again.');
  //     return false;
  //   }
  // };





  if (!location.state) {
    setNeedsRefresh(true);
    navigate(-1);
    return null;
  }





  const handleConfirmTicketClick = async () => {
    // 1. Create a custom event to bypass the popstate handler
    // const bypassEvent = new CustomEvent('customBackNavigation', {
    //   detail: { fromSeatConflict: true }
    // });

    try {
      const response = await ScreenLayoutServices.createScreenLayout({
        showtimeId,
        theatreId,
        bookedSeats,
        date,
        time,
        lockedById: _id,
        lockedByPhoneNumber: null
      });


      console.log('response====================================', response)
      // if (response.success === false) {
      //   alert("❌ Some seats are already booked. Please select different seats.");

      //   // 2. Dispatch the custom event before navigating
      //   window.dispatchEvent(bypassEvent);

      //   // 3. Use replace navigation to avoid history entry
      //   navigate(-1, { 
      //     replace: true,
      //     state: { forceReload: true, fromSeatConflict: true }
      //   });
      //   return;
      // }

      if (response.success === false) {
        // 1. Manually modify history to bypass confirmation
        alert("❌ Some seats are already booked. Please select different seats.");
        bypassPopconfirm.current = true;
        navigate(-1)
        return
        // navigate('/moviebooking')
      }

      // Success case remains the same
      if (response?.message.includes('successfully')) {
        // If coupon valid in v2 flow, place a redemption hold
        if (!(paymentGateway === 'PhonePe' || paymentGateway === 'Cash') && couponValid && bookingId) {
          try {
            await PaymentServices.redeemCoupon({ bookingId, serviceType: 'Tickets', serviceId: theatreId, code: couponCode });
            sessionStorage.setItem('couponBookingId', bookingId);
          } catch (e) { console.error('redeemCoupon failed', e); }
        }
        // toggleModal();
        handleModalSubmit(phoneNumber);
        // setShowModal(true);
      }
    } catch (err) {
      console.error("Error:", err);
      alert("An error occurred. Please try again.");
    }
  };


  // For UI 
  const groupedSeats = bookedSeats.reduce((acc, seat) => {
    if (!acc[seat.sectionName]) {
      acc[seat.sectionName] = [];
    }
    acc[seat.sectionName].push(seat.seatNumber);
    return acc;
  }, {});

  return (
    <div className="max-w-4xl mx-auto mt-4 p-6 bg-white rounded-2xl shadow-xl">
      <BookingBreadcrumb currentStep="confirm" onBack={handleCancelBooking} />
      <div className="mb-6">
        <div className={`flex justify-between items-center mb-6 p-2 rounded-xl ${timeRemaining <= 60 ? 'bg-red-50' : 'bg-gray-50'}`}>
          <h3 className="text-base font-semi-bold">🎟 Booking Confirmation</h3>
          <div className={`text-md font-bold ${timeRemaining <= 60 ? 'text-red-600' : 'text-blue-600'}`}>Time Remaining: {formatTime(timeRemaining)}</div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <div className="rounded-xl overflow-hidden mb-4 shadow-md h-40 w-full bg-cover bg-center" style={{ backgroundImage: `url(${movie?.imageUrl})` }} />
            <div className="mb-6">
              <h3 className="text-base font-medium mb-2">Booking Details</h3>
              <h3 className="text-base font-semibold">{movie?.Name}</h3>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <p className="text-[14px] text-gray-500">Show Date & Time</p>
                  <p className="text-[14px] font-semi-bold">{moment(date).format("MMMM Do YY")} | {time}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mt-0">Selected Seats</p>
                  {/* <div className="flex flex-wrap gap-2 mt-2"> */}
                    {/* {bookedSeats.map((seat, index) => (
                      <span key={index} className="px-3 py-1 bg-gray-100 rounded-full text-sm">
                        {`${seat.sectionName} - ${seat.seatNumber}`}
                      </span>
                    ))} */}

                    {Object.entries(groupedSeats).map(([section, seatNumbers], idx) => (
                      <div key={idx} className="flex flex-wrap gap-2 mt-1">
                        <span className="font-bold text-md">{section}:</span>
                        <span className="font-md">{seatNumbers.join(',')}</span>
                        {/* {seatNumbers.map((num, i) => (
                          <span key={i} className="px-3 py-1 bg-gray-100 rounded-full text-sm">
                            {num}
                          </span>
                        ))} */}
                      </div>
                    ))}

                  {/* </div> */}
                </div>
              </div>
            </div>


            {/* <p className="text-gray-500 mt-2">{movie?.language} • {movie?.certificate}</p> */}
          </div>

          <div>

            {error && <div className="mt-4 p-3 bg-red-100 text-red-700 rounded-lg">{error}</div>}


            <p className={`mt-6 italic ${isExpired ? 'text-red-500' : 'text-gray-500'}`}>{isExpired ? 'Your session expired. Please start over.' : 'Complete your payment within time.'}</p>


            <div className="flex gap-4 mt-6">
              <button
                onClick={handleCancelBooking}
                //  onClick={handleCancelClick}
                disabled={isExpired} className={`flex-1 py-3 px-6 rounded-xl font-medium text-sm ${isExpired ? 'bg-gray-300 text-gray-500' : 'bg-white border border-red-500 text-red-500 hover:bg-red-50'}`}>Cancel Booking</button>
              <button
                //  onClick={toggleModal}
                onClick={handleConfirmTicketClick}
                disabled={isExpired || !paymentMethod || loadingPricing} className={`flex-1 py-3 px-6 rounded-xl font-medium text-sm ${isExpired || !paymentMethod || loadingPricing ? 'bg-gray-300 text-gray-500' : 'bg-black text-white hover:bg-gray-800'}`}>Generate Ticket</button>
            </div>


            <div className="mt-6">
              <h3 className="text-xl font-medium mb-2">Select Payment Gateway</h3>
              <div className="flex gap-6 flex-wrap">
                {/* Legacy options always shown */}
                {['PhonePe','Cash'].map(gw => (
                  <label key={gw} className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="paymentGateway"
                      checked={paymentGateway === gw}
                      onChange={() => {
                        // Set state, then explicitly calculate with gateway override to avoid stale state
                        setPaymentGateway(gw);
                        const method = gw === 'Cash' ? 'Cash' : 'PhonePe';
                        setPaymentMethod(method);
                        setPaymentChannel('All');
                        // Reset coupon when switching back to legacy
                        setCouponCode('');
                        setCouponValid(false);
                        // Pass explicit null to ensure coupon is removed immediately
                        calculatePricing(method, gw, 'All', null);
                      }}
                    />
                    <span>{gw === 'Cash' ? 'Counter' : gw}</span>
                  </label>
                ))}
                {/* Dynamic gateways from config */}
                {console.log('availableGateways========',availableGateways)}
                {availableGateways
                  .filter(({ gateway }) => gateway !== 'PhonePe' && gateway !== 'Cash')
                  .map(({ gateway, methods = [] }) => (
                  <label key={gateway} className="flex items-center gap-2">
                    <input
                      type="radio"
                      name="paymentGateway"
                      checked={paymentGateway === gateway}
                      onChange={() => {
                        setPaymentGateway(gateway);
                        setPaymentMethod('Online');
                        // Default payment channel to first available method if provided
                        const nextChannel = (methods && methods.length > 0) ? methods[0] : 'All';
                        setPaymentChannel(nextChannel);
                        calculatePricing('Online', gateway, nextChannel, couponValid ? couponCode : undefined);
                      }}
                    />
                    <span>{gateway}</span>
                  </label>
                ))}
              </div>

              {/* Payment Method (v2 only) */}
              {!(paymentGateway === 'PhonePe' || paymentGateway === 'Cash') && (
                <div className="mt-4">
                  <h4 className="text-sm font-medium mb-2">Payment Method</h4>
                  <select
                    className="border rounded px-3 py-2"
                    value={paymentChannel}
                    onChange={(e) => {
                      const newChannel = e.target.value;
                      setPaymentChannel(newChannel);
                      calculatePricing(paymentMethod || 'Online', paymentGateway, newChannel, couponValid ? couponCode : undefined);
                    }}
                  >
                    {(() => {
                      const gw = availableGateways.find(g => g.gateway === paymentGateway);
                      const methods = gw?.methods && gw.methods.length > 0 ? gw.methods : ['All','Credit Card','Debit Card','UPI','Netbanking'];
                      return methods.map(m => <option key={m} value={m}>{m}</option>);
                    })()}
                  </select>
                </div>
              )}

              {/* Coupon (v2 only) */}
              {!(paymentGateway === 'PhonePe' || paymentGateway === 'Cash') && (
                <div className="mt-4 flex items-center gap-2">
                  <input
                    type="text"
                    className="border rounded px-3 py-2 flex-1"
                    placeholder="Enter coupon code"
                    value={couponCode}
                    onChange={(e)=>{ setCouponCode(e.target.value.toUpperCase()); setCouponValid(false); }}
                  />
                  {!couponValid ? (
                    <button
                      className="px-4 py-2 bg-blue-600 text-white rounded"
                      onClick={async ()=>{
                        try {
                          const resp = await PaymentServices.validateCoupon({ serviceType: 'Tickets', serviceId: theatreId, code: couponCode });
                          if (resp.success && resp.valid) {
                            setCouponValid(true);
                            // Recalculate immediately with explicit coupon to avoid state lag
                            calculatePricing(paymentMethod || 'Online', paymentGateway, paymentChannel, couponCode);
                          } else {
                            setCouponValid(false);
                            alert('Invalid or expired coupon');
                          }
                        } catch (e) {
                          console.error(e);
                          alert('Failed to validate coupon');
                        }
                      }}
                      disabled={!couponCode}
                    >Validate</button>
                  ) : (
                    <span className="inline-flex items-center h-10 px-3 text-green-700 text-sm font-medium bg-green-50 border border-green-200 rounded">
                      Applied
                    </span>
                  )}
                  {couponValid && (
                    <button
                      className="px-4 py-2 bg-gray-300 rounded"
                      onClick={() => {
                        setCouponCode('');
                        setCouponValid(false);
                        // Pass explicit null to force immediate removal (avoids async state lag)
                        calculatePricing(paymentMethod || 'Online', paymentGateway, paymentChannel, null);
                      }}
                    >Remove</button>
                  )}
                </div>
              )}
            </div>

            <div className="mb-6">
              {/* <h3 className="text-xl font-medium mb-1">Payment Breakdown</h3> */}
              {loadingPricing ? <div className="animate-spin h-8 w-8 border-t-2 border-b-2 border-blue-500 rounded-full mx-auto"></div>
                : pricing ? <PaymentSplitDetails pricing={pricing} />
                  : <p className="text-gray-500">Pricing details not available</p>}
            </div>




          </div>
        </div>
      </div>

      {/* {showModal && (
        <TicketModal
          onClose={toggleModal}
          onSubmit={handleModalSubmit}
          setPhoneNumber={setPhoneNumber}
          phoneNumber={phoneNumber}
        />
      )} */}
    </div>
  );
};

const TicketModal = ({ onClose, onSubmit, setPhoneNumber, phoneNumber }) => {
  const [phoneError, setPhoneError] = useState('');
  const inputRef = useRef(null);

  useEffect(() => { if (inputRef.current) inputRef.current.focus(); }, []);

  const handlePhoneChange = (e) => {
    const val = e.target.value.replace(/\D/g, '').slice(0, 10);
    setPhoneNumber(val);
    if (phoneError) setPhoneError('');
  };

  const handleSubmit = () => {
    if (!phoneNumber || phoneNumber.length !== 10) {
      setPhoneError('Enter a valid 10-digit number');
      return;
    }
    onSubmit(phoneNumber);
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 p-4">
      <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-sm">
        <h2 className="text-xl font-semibold mb-4">Enter Phone Number</h2>
        <div className="flex mb-4">
          <span className="px-3 py-2 bg-gray-100 border border-r-0 border-gray-300 rounded-l-md">+91</span>
          <input
            ref={inputRef}
            type="tel"
            value={phoneNumber}
            onChange={handlePhoneChange}
            maxLength={10}
            inputMode="numeric"
            className={`border p-2 w-full rounded-md ${phoneError ? 'border-red-500' : 'border-gray-300'}`}
            placeholder="10-digit phone number"
          />
        </div>
        {phoneError && <p className="text-red-500 text-sm mb-3">{phoneError}</p>}
        <div className="flex justify-between">
          <button onClick={onClose} className="bg-gray-300 text-gray-700 px-4 py-2 rounded-md hover:bg-gray-400">Cancel</button>
          <button onClick={handleSubmit} className="bg-black text-white px-4 py-2 rounded-md hover:bg-gray-800">Confirm & Pay</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmTicket;
